// extracted by mini-css-extract-plugin
export default {"secondaryButton":"styles_secondaryButton__I1xtU","disabled":"styles_disabled__kR9mz","selected":"styles_selected__NOGYM","hovered":"styles_hovered__-V2N-"};